const isDev = process.env.NODE_ENV === 'development'

const UserRoles = {
    Admin: 'ADMIN',
    Owner: 'OWNER',
    Warehouse: 'WAREHOUSE',
    Lab: 'LAB',
    Sales: 'SALES',
    Manager: 'MANAGER',
}

const Tags = {}

const Responses = {
    Failed: 'FAIL',
    Success: 'SUCCESS',
    Exists: 'EXISTS',
    SpotLocked: 'SPOT_LOCKED',
}

const PackagingType = {
    BigBag: 'BIGBAG',
    Sb25: 'SB25',
    Sb50: 'SB50',
}

const PackagingDefaults = {
    BIGBAG: { type: 'BIGBAG', weight: 1150, bagCount: null },
    SB25: { type: 'SB25', weight: 25, bagCount: 36 },
    SB50: { type: 'SB50', weight: 50, bagCount: 16 },
}

const ReducerActions = {
    Add: 'ADD',
    Update: 'UPDATE',
    Delete: 'DELETE',
    Replace: 'REPLACE',
}

const Actions = {
    Add: 'ADD',
    Update: 'UPDATE',
    Delete: 'DELETE',
}

const ProductStatus = {
    Ready: 'READY',
    Repackaging: 'REPACKAGING',
    Removed: 'REMOVED',
    Sent: 'SENT',
    Stored: 'STORED',
}

export {
    UserRoles,
    Tags,
    Responses,
    ReducerActions,
    Actions,
    ProductStatus,
    PackagingType,
    PackagingDefaults,
    isDev,
}